// ProtectedRoute.tsx
import { Navigate } from "react-router-dom";
import { isAuthenticated, isCustomerAuthenticated } from "./auth";

const ProtectedRoute = ({ children }: { children: any }) => {
    return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

const CustomerProtectedRoute = ({ children }: { children: any }) => {
    return isCustomerAuthenticated() ? (
        children
    ) : (
        <Navigate to="/login" replace />
    );
};
export { ProtectedRoute, CustomerProtectedRoute };
